import { Component, OnInit } from '@angular/core';
import { MemberService, WorksheetQuery, WorksheetService, WorksheetType } from '@fgb/core';
import { Representative } from 'projects/core/src/lib/modules/account/member/models/representative.model';
import { Observable, catchError, map, of, tap } from 'rxjs';

@Component({
  selector: 'fgb-representative',
  templateUrl: './representative.component.html',
  styleUrl: './representative.component.scss'
})
export class RepresentativeComponent implements OnInit {
  private readonly worksheetRoute = 'representative';

  representative$: Observable<Representative | null>
  worksheetImage$: Observable<string | null> = this.worksheetQuery.getWorksheetByRoute(this.worksheetRoute).pipe(
    map((worksheets) => {
      const item = worksheets
        .filter((worksheet) => worksheet.Active === 1)
        .flatMap((worksheet) => worksheet.Items ?? [])
        .find((worksheetItem) => worksheetItem.WorksheetType === WorksheetType.Gallery && worksheetItem.Active === 1 && !!worksheetItem.Image);
      return item?.Image ?? null;
    })
  );

  constructor(
    private memberService: MemberService,
    private worksheetService: WorksheetService,
    private worksheetQuery: WorksheetQuery
  ) { }
  image: any

  ngOnInit(): void {
    if (!this.worksheetQuery.hasRoute(this.worksheetRoute)) {
      this.worksheetService.fetchWorksheetByRoute(this.worksheetRoute).subscribe();
    }

    this.representative$ = this.memberService.getRepresentative().pipe(
      tap(rep => {
        this.getImageFromService(rep.Id)
      }),
      catchError(() => of(null))
    );
  }

  getImageFromService(id: number) {
    this.memberService.getRepresentativeImage(id).subscribe(
      (data) => {
        this.createImageFromFile(data);
      }
    );
  }

  createImageFromFile(file: Blob | undefined) {
    let reader = new FileReader();
    reader.addEventListener(
      'load',
      () => {
        this.image = reader.result;
      },
      false
    );

    if (file && file.size > 0) {
      reader.readAsDataURL(file);
    }
  }

  onImageError(): void {
    this.image = null;
  }
}
